// extracted by mini-css-extract-plugin
export var bounce = "_h1-1";
export var generatingText = "_h1-6";
export var lightning = "_h1-4";
export var popup = "_h1-5";
export var progressBar = "_h1-7";
export var progressFill = "_h1-8";
export var progressShimmer = "_h1-9";
export var progressText = "_h1-a";
export var shimmer = "_h1-3";
export var uploadIcon = "_h1-0";
export var uploadingText = "_h1-2";